import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React from "react";

interface Props {
    label: React.ReactNode;
    checked: boolean;
    onChanged: (checked: boolean) => void;

    disabled?: boolean;
    testId?: string;

    className?: string;
    size?: "small" | "medium";
    color?: "primary" | "secondary" | "default";
}

const QACheckbox: React.FC<Props> = props => {
    return (
        <FormControlLabel
            data-cy={`${props.testId}-Label`}
            disabled={props.disabled}
            label={props.label}
            className={props.className}
            control={(
                <Checkbox
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    data-cy={props.testId}
                    disabled={props.disabled}
                    checked={props.checked}
                    size={props.size}
                    onChange={(e, checked) => props.onChanged(checked)}
                    color={props.color || "primary"} />
            )} />
    );
};

export default QACheckbox;
